<template>
    <div>
        <div v-if="isPc==true" class="breadcrumb greyfont warp">
            <ul>
                <li><router-link to="/center">个人中心</router-link></li>
                <li>
                    <span>-</span>
                    <p>线上挂号</p>
                </li>
            </ul>
        </div>

        <div :class="isPc==true?'routerpage warp':''">
            <div :class="isPc==true?'tabar_bg':'tabar_bg-mob'">
                <p>线上挂号</p>
            </div>

            <HospitalGUI v-if="isPc==true"></HospitalGUI>

            <ul :class="isPc==true?'register_crumb':'register_crumb-mob warp-mob'">
                <p>流程:</p>
                <li style="color: #006fac">选择科室</li>
                →
                <li :style="crumb1==true?'color: #006FAC':''">选择值班医生</li>
                →
                <li :style="crumb2==true?'color: #006FAC':''">选择挂号时间段</li>
                →
                <li :style="crumb3==true?'color: #006FAC':''">挂号成功</li>
            </ul>

            <div v-if="view==0 " :class="isPc==true?'regist_cont':'regist_cont-mob'">
                <div :class="isPc==true?'regist_cont_box':''">
                    <div :class="isPc==true?'regist_cont_box_header':'regist_cont_box_header-mob'"><p>选择科室</p></div>
                    <ul v-if="officeList" class="regist_cont_box_list">
                        <li
                            style="height: 45px"
                            :style="choiceOffice==index?'background-color: #006FAC; color: #fff;':''"
                            @click="selectOffice(item,index)"
                            v-for="(item,index) in officeList"
                            :key="index"
                        >
                            {{ item }}
                        </li>
                    </ul>
                </div>
                <div :class="isPc==true?'regist_cont_btn':'regist_cont_btn-mob warp-mob'" style="justify-content: center">
                    <div class="regist_cont_btn_next" @click="nextDoctor()">下一步</div>
                </div>
            </div>

            <div v-if="view==1 " :class="isPc==true?'regist_cont':'regist_cont-mob'">
                <div :class="isPc==true?'regist_cont_box':''">
                    <div :class="isPc==true?'regist_cont_box_header':'regist_cont_box_header-mob'"><p>选择值班医生</p></div>
                    <ul class="regist_cont_box_list">
                        <li
                            :class="isPc==true?'regist_cont_box_list_doctor':'regist_cont_box_list_doctor-mob'"
                            :style="doctor_id==item.id?'background-color: #006FAC':''"
                            v-for="(item,index) in doctorList"
                            :key="index"
                            @click="doctor_id = item.id"
                        >
                            <p :style="doctor_id==item.id?'color: #fff':''">{{ item.department }}</p>
                            <span v-if="isPc==false" :style="doctor_id==item.id?'color: #fff':''">：</span>
                            <h1 :style="doctor_id==item.id?'color: #fff':''">{{ item.fullname }}</h1>
                        </li>
                    </ul>
                </div>
                <div :class="isPc==true?'regist_cont_btn':'regist_cont_btn-mob warp-mob'">
                    <div class="regist_cont_btn_last" @click="lastOffice()">上一步</div>
                    <div class="regist_cont_btn_next" @click="nextTime()">下一步</div>
                </div>
            </div>

            <div v-if="view==2 " :class="isPc==true?'regist_cont':'regist_cont-mob'">
                <div v-if="time_slot" :class="isPc==true?'regist_cont_box':'regist_cont_box_time-mob'">
                    <div :class="isPc==true?'regist_cont_box_header':'regist_cont_box_header-mob'"><p>选择挂号时间段</p></div>
                    <ul v-if="isPc==true" class="regist_cont_box_date greyfont">
                        <li v-for="(item,index) in time_slot" :key="index">{{item}}</li>
                    </ul>

                    <div v-show="isPc==false" id="nav" style="display: flex">
                        <div class="header_nav_list-mob">
                            <div class="time-item" style="color: #000" v-for="(item,index) in time_slot" :key="index">{{item}}</div>
                        </div>
                    </div>

                    <ul class="regist_cont_box_list">
                        <li class="regist_cont_box_list_regTime" v-for="(item,index) in regTime" :key="index">
                            <div class="regist_cont_box_list_regTime_time deepbluefont">
                                <p>{{ item.noon }}</p>
                                <h1>{{ item.daytime }}</h1>
                            </div>
                            <div class="regist_cont_box_list_regTime_money deepbluefont">{{item.money}}元</div>
                        </li>
                    </ul>
                </div>
                <div :class="isPc==true?'regist_cont_btn':'regist_cont_btn-mob warp-mob'">
                    <div class="regist_cont_btn_last" @click="lastDoctor()">上一步</div>
                    <div class="regist_cont_btn_next" @click="nextInfo()">下一步</div>
                </div>
            </div>

            <div v-if="view==3 " :class="isPc==true?'regist_cont':'regist_cont-mob'">
                <div :class="isPc==true?'regist_cont_box':''">
                    <div :class="isPc==true?'regist_cont_box_header':'regist_cont_box_header-mob'"><p>挂号详情</p></div>
                    <div class="regist_cont_box_img greenfont">
                        <img src="../static/imgs/74f414e678a9b85713189cbc61750502_5071273.png" />
                        <h1>您已挂号成功！</h1>
                    </div>
                    <ul :class="isPc==true?'regist_cont_box_getdata greyfont':'regist_cont_box_getdata-mob greyfont'">
                        <li>
                            <h1>科&#8195;&#8195;室：</h1>
                            <p class="deepbluefont">{{ getInfo.office }}</p>
                        </li>
                        <li>
                            <h1>值班医生：</h1>
                            <p class="deepbluefont">{{ getInfo.doctor }}</p>
                        </li>
                        <li>
                            <h1>挂号时间：</h1>
                            <p class="deepbluefont">{{ getInfo.time }}</p>
                        </li>
                        <li>
                            <h1>挂号费用：</h1>
                            <p style="color: #e13113">{{ getInfo.cost }}</p>
                        </li>
                    </ul>
                </div>
                <div class="regist_cont_btn" style="justify-content: center">
                    <div class="regist_cont_btn_next" @click="backcenter()">返回个人中心</div>
                </div>
            </div>
        </div>
        <div v-if="isPc==false" style="margin-top: 50px" class="foot-mob"></div>
    </div>
</template>

<script>
    import HospitalGUI from '../components/HospitalGUI.vue';
    export default {
        name: 'WebLijinhospitalRegisterOnline',
        components: {
            HospitalGUI,
        },
        data() {
            return {
                isPc: true,
                view: 0, //视图
                crumb1: false, //进度条2
                crumb2: false, //进度条3
                crumb3: false, //进度条4
                getInfo: {
                    //成功信息
                    office: '内科',
                    doctor: '专家——坤坤',
                    time: '上午 9:00~10:00',
                    cost: '20.00元',
                },
                officeList: null,
                choiceOffice: 0, //选择科室
                doctorList: null,
                doctor_id: 0,
                regTime: [
                    { noon: '上午', daytime: '6:00~8:00', money: '20.00' },
                    { noon: '上午', daytime: '8:00~9:00', money: '20.00' },
                    { noon: '上午', daytime: '9:00~11:00', money: '20.00' },
                    { noon: '上午', daytime: '11:00~12:00', money: '20.00' },
                    { noon: '下午', daytime: '1:00~2:00', money: '20.00' },
                    { noon: '下午', daytime: '3:00~4:00', money: '20.00' },
                    { noon: '下午', daytime: '4:00~5:00', money: '20.00' },
                    { noon: '下午', daytime: '5:00~6:00', money: '20.00' },
                ],
                time_slot: null,
            };
        },

        mounted() {
            if (document.body.clientWidth <= 820) {
                this.isPc = false;
                console.log(this.isPc);
            } else {
                this.isPc = true;
                console.log(this.isPc);
            }
            this.getdata();
        },

        methods: {
            getdata() {
                // officeList 科室
                this.$axios({
                    url: 'http://www.ljxzxyy.cn/api/index/department',
                })
                    .then((res) => {
                        //请求成功
                        console.log('department', res.data);
                        this.officeList = res.data.data;
                    })
                    .catch((error) => {
                        //请求失败
                        console.log('department', error);
                    });
            },
            getdata2() {
                // doctorList 医师
                this.$axios({
                    url: 'http://www.ljxzxyy.cn/api/index/doctor',
                    params: {
                        department: this.officeList[this.choiceOffice],
                    },
                })
                    .then((res) => {
                        //请求成功
                        console.log('doctor', res.data);
                        this.doctorList = res.data.data;
                    })
                    .catch((error) => {
                        //请求失败
                        console.log('doctor', error);
                    });
            },
            getTimeSlot() {
                // 日期
                this.time_slot = [];
                let weekarr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
                let today = new Date();
                today.setDate(today.getDate() + 1);
                this.time_slot[0] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                today.setDate(today.getDate() + 1);
                this.time_slot[1] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                today.setDate(today.getDate() + 1);
                this.time_slot[2] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                today.setDate(today.getDate() + 1);
                this.time_slot[3] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                today.setDate(today.getDate() + 1);
                this.time_slot[4] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                today.setDate(today.getDate() + 1);
                this.time_slot[5] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                today.setDate(today.getDate() + 1);
                this.time_slot[6] = today.getMonth() - -1 + '月' + today.getDate() + '日 ' + weekarr[today.getDay()];
                // 时间
                this.$axios({
                    url: 'http://www.ljxzxyy.cn/api/index/getsetting',
                })
                    .then((response) => {
                        //请求成功
                        console.log('getsetting', response.data);
                        let setting = response.data.data;
                        console.log(setting.registration_data);
                    })
                    .catch((error) => {
                        //请求失败
                        console.log('getsetting', error);
                    });
            },
            getview() {
                if (this.view == 0) {
                    this.crumb1 = false;
                    this.crumb2 = false;
                    this.crumb3 = false;
                }
                if (this.view == 1) {
                    this.crumb1 = true;
                    this.crumb2 = false;
                    this.crumb3 = false;
                }
                if (this.view == 2) {
                    this.crumb1 = true;
                    this.crumb2 = true;
                    this.crumb3 = false;
                }
                if (this.view == 3) {
                    this.crumb1 = true;
                    this.crumb2 = true;
                    this.crumb3 = true;
                }
            },
            // 科室列表选中
            selectOffice(item, index) {
                this.choiceOffice = index;
            },
            //下一步选择医生
            nextDoctor() {
                this.getdata2();
                this.view = 1;
                this.getview();
            },
            // 下一步选择时间
            nextTime() {
                if (this.doctor_id > 0) {
                    this.getTimeSlot();
                    this.view = 2;
                    this.getview();
                }
            },
            // 下一步获取结果
            nextInfo() {
                this.view = 3;
                this.getview();
            },
            // 上一步选择科室
            lastOffice() {
                this.view = 0;
                this.getview();
            },
            // 上一部选择医生
            lastDoctor() {
                this.view = 1;
                this.getview();
            },
            backcenter() {
                this.$router.push('/center');
            },
            cur() {
                console.log(this.aaa);
            },
            choiceDoctor() {
                this.view = 1;
            },
            scrollInit() {
                // 获取要绑定事件的元素
                const nav = document.getElementById('nav');
                var flag; // 鼠标按下
                var downX; // 鼠标点击的x下标
                var scrollLeft; // 当前元素滚动条的偏移量
                nav.addEventListener('mousedown', function (event) {
                    flag = true;
                    downX = event.clientX; // 获取到点击的x下标
                    scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
                });
                nav.addEventListener('mousemove', function (event) {
                    if (flag) {
                        // 判断是否是鼠标按下滚动元素区域
                        var moveX = event.clientX; // 获取移动的x轴
                        var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
                        this.scrollLeft = scrollLeft - scrollX; // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
                        console.log(scrollX);
                    }
                });
                // 鼠标抬起停止拖动
                nav.addEventListener('mouseup', function () {
                    flag = false;
                });
                // 鼠标离开元素停止拖动
                nav.addEventListener('mouseleave', function () {
                    flag = false;
                });
            },
        },
    };
</script>

<style lang="scss" scoped></style>
